import React from 'react';
import { Button } from '@material-ui/core';
import { Upload } from 'react-feather';
interface IProps {
  importButtonLabel: string;
  onFileSelected: (file: File) => void;
  fileTypesAsCsv?: string;
  id: string;
}

const UploadButton: React.FC<IProps> = ({
  importButtonLabel,
  id,
  fileTypesAsCsv = '.csv, .tsv, text/plain',
  onFileSelected
}) => {
  const openFileSelector = () => {
    document.getElementById(id)?.click();
  };

  return (
    <div>
      <form encType={'multipart/form-data'}>
        <input
          onChange={({ target: { files } }) => {
            const file = files ? files[0] : null;
            if (file) {
              onFileSelected(file);
            }
          }}
          id={id}
          style={{ display: 'none' }}
          type="file"
          accept={fileTypesAsCsv}
        />
        <Button variant="contained" color="primary" onClick={openFileSelector}>
          <Upload style={{ marginRight: '4px' }} />
          {importButtonLabel}
        </Button>
      </form>
    </div>
  );
};

export default UploadButton;
